import Vue from "vue";
import Vuex from "vuex"
import {getAllAgreement, getVisitorConfigSetting} from "@/api/setting-api";

Vue.use(Vuex)

let agreementHasGetSuccess = false

const TERMINAL_LS_KEY = "pad.terminal.info"

function readTerminalInfo() {
    try {
        return JSON.parse(localStorage.getItem(TERMINAL_LS_KEY)) || {}
    } catch (e) {
        return {}
    }
}

function saveTerminalInfo(patch) {
    const info = readTerminalInfo()
    Object.keys(patch).forEach(k => {
        if (patch[k] == null) {
            delete info[k]
        } else {
            info[k] = String(patch[k])
        }
    })
    localStorage.setItem(TERMINAL_LS_KEY, JSON.stringify(info))
}

const terminalInfo = readTerminalInfo()

export default new Vuex.Store({
    state: {
        homeInfo: {
            HOME_WELCOME: '',
            HOME_BANNER_LIST: [],
        },
        pageSetting: [], // 页面配置信息


        menuData: {},

        allCategaryList: [],

        privacyAgreement: {valid: false, content: '', focusRead: false},
        userAgreement: {valid: false, content: '', focusRead: false},
        signEnterAgreement: {valid: false, content: '', focusread: false},
        signLeaveAgreement: {valid: false, content: '', focusread: false},
        visitorAgreement: {valid: false, content: '', focusRead: false},

        token: terminalInfo.token || '',
        areaId: terminalInfo.areaId || '',
        deviceId: terminalInfo.deviceId || "",
        areaInfo: {verify: 0},

        selectEmployee: null,

        visitorConfigSetting: {
            value: "NONE", // NONE, ID, PASSPORT, ALL
            depends: [  // dependField 目前只有 email
                {name: "ID", dependField: ""},
                {name: "PASSPORT", dependField: ""},
            ]
        }
    },

    actions: {

        // 访客信息配置（VISITOR_BOOK 身份证等字段显隐）。HomePage 会拉取；
        // 深链/子路由刷新（如 addInfo/SignEnter 直达）时 HomePage 不挂载，由页面自行兜底调用。
        // async：SignEnterPage 构建字段前会 await 本 action，确保配置就绪后再决定证件字段显隐
        async requestVisitorConfigSetting({commit}) {
            try {
                const {data} = await getVisitorConfigSetting()
                if (data.code === 200 && data.data.length >= 1) {
                    let setting = {
                        value: "NONE",
                        depends: [{name: "ID", dependField: ""}, {name: "PASSPORT", dependField: ""}],
                        idCardNo: 2,
                        nationality: 1,
                        passport: 1,
                    }
                    data.data.forEach(item => {
                        if (item.type === "VISITOR_BOOK" && item.content) {
                            try {
                                const c = JSON.parse(item.content)
                                if (c) setting = Object.assign(setting, c)
                            } catch (e) {
                                console.error("parse VISITOR_BOOK content err", e)
                            }
                        }
                    })
                    commit('setVisitorConfigSetting', setting)
                }
            } catch (err) {
                console.log("requestVisitorConfigSetting error " + err)
            }
        },

        requestAllAgreement({commit}) {
            if (agreementHasGetSuccess) return

            getAllAgreement().then(({data}) => {
                console.log("getAllAgreement", data)
                if (data.code === 200) {
                    agreementHasGetSuccess = true
                    data.data.forEach(item => {
                        if (item.type === "USER_AGREEMENT") {
                            let content = item.content
                            let focusRead = false
                            if (item.readFlag) focusRead = item.readFlag.includes("terminal")
                            let valid = item.state === "VALID"
                            commit('setUserAgreement', {content, valid, focusRead})
                        } else if (item.type === "VISITOR_NOTICE") {
                            let content = item.content
                            let focusRead = false
                            if (item.readFlag) focusRead = item.readFlag.includes("terminal")
                            let valid = item.state === "VALID"
                            commit('setVisitorAgreement', {content, valid, focusRead})
                        } else if (item.type === "ENTER_NOTICE") {
                            let content = item.content
                            let focusRead = false
                            if (item.readFlag) focusRead = item.readFlag.includes("terminal")
                            let valid = item.state === "VALID"
                            commit('setSignEnterAgreement', {content, valid, focusRead})
                        } else if (item.type === "LEAVE_NOTICE") {
                            let content = item.content
                            let focusRead = false
                            if (item.readFlag) focusRead = item.readFlag.includes("terminal")
                            let valid = item.state === "VALID"
                            commit('setSignLeaveAgreement', {content, valid, focusRead})
                        } else if (item.type === "SECRET_AGREEMENT") {
                            let content = item.content
                            let focusRead = false
                            if (item.readFlag) focusRead = item.readFlag.includes("terminal")
                            let valid = item.state === "VALID"
                            commit('setPrivacyAgreement', {content, valid, focusRead})
                        }
                    })
                }
            }).catch(err => {
                console.log("getAllAgreement error" + err)
            })
        },
    },

    mutations: {
        setMenuData(state, data) {
            state.menuData = data
        },


        setAllCategary(state, data) {
            state.allCategaryList = data;
        },

        setPrivacyAgreement(state, data) {
            state.privacyAgreement = data;
        },

        setVisitorAgreement(state, data) {
            state.visitorAgreement = data;
        },

        setUserAgreement(state, data) {
            state.userAgreement = data;
        },

        setSignEnterAgreement(state, data) {
            state.signEnterAgreement = data;
        },
        setSignLeaveAgreement(state, data) {
            state.signLeaveAgreement = data;
        },
        setToken(state, data) {
            state.token = data;
            saveTerminalInfo({token: data});
        },

        clearTerminalSession(state) {
            state.token = ''
            state.areaId = ''
            state.deviceId = ''
            saveTerminalInfo({token: null, areaId: null, deviceId: null})
        },

        setPageSetting(state, data) {
            state.pageSetting = data
        },

        setAreaId(state, data) {
            state.areaId = data
            saveTerminalInfo({areaId: data})
        },
        setDeviceId(state, data) {
            state.deviceId = data
            saveTerminalInfo({deviceId: data})
        },

        setAreaInfo(state, data) {
            state.areaInfo = data
        },

        setSelectEmployee(state, data) {
            state.selectEmployee = data
        },

        setHomeInfo(state, data) {
            state.homeInfo = data
        },

        setVisitorConfigSetting(state, data) {
            state.visitorConfigSetting = data
        }
    },

    getters: {
        icHidden(state) {
            return state.visitorConfigSetting && state.visitorConfigSetting.idCardNo === 1
        },

        noChildernMenuData(state) {
            return state.menuData.children.filter(item => !item.children)
        },

        hasChildernMenuData(state) {
            return state.menuData.children.filter(item => item.children)
        },

        getPrivacyAgreement(state) {
            return state.privacyAgreement
        },

        getVisitorAgreement(state) {
            return state.visitorAgreement
        },

        getUserAgreement(state) {
            return state.userAgreement
        },

        getSignEnterAgreement(state) {
            return state.signEnterAgreement
        },

        getSignLeaveAgreement(state) {
            return state.signLeaveAgreement
        }
    }
})
